import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {buildABTestCookie} from "@pg-mono/ab-testing";
import {getAmplitudeDeviceId, getAmplitudeUserId, getResolvedFeatureFlags, waitForAmplitudeInitialization} from "@pg-mono/amplitude";
import type {IDevToolsConfig} from "@pg-mono/devtools";
import {resolveDevtoolsEnabled} from "@pg-mono/devtools";
import {PERFORMANCE_DEBUG_EVENT_NAME, PERFORMANCE_DEBUG_STORAGE_KEY, PERFORMANCE_DEBUG_WINDOW_KEY} from "@pg-mono/performance-debug";
import {getCookie} from "@pg-mono/request";
import {TURNSTILE_SIMULATION_CHALLENGE_MODE, TURNSTILE_SIMULATION_FAIL_MODE} from "@pg-mono/turnstile";

import {ongoingABTests} from "../common/ab_testing/ongoing_ab_tests";
import {RP_TURNSTILE_SIMULATION_STORAGE_KEY} from "../common/app/constants/storage_keys";
import {CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP, RP_LEAD_FORMS_PERFORMANCE_GROUP} from "../common/app/performance_debug";
import {amplitudeApiKey, buildImageTag, rpFeatureFlagDevtools, rpInternalApiCookieDomain} from "../common/app/read_rp_environment_variables";

declare global {
    interface Window {
        __AMPLITUDE_FETCHED_FLAGS__?: string[];
    }
}

const getABTestCurrentVariant = (testId: string, variants: string[]): string | null => {
    const cookieValue = getCookie(testId);

    if (cookieValue === null) {
        return null;
    }

    // Legacy cookies may store variant index instead of name - resolve to name
    const index = parseInt(cookieValue, 10);

    if (String(index) === cookieValue && index >= 0 && index < variants.length) {
        return variants[index];
    }

    return cookieValue;
};

export const initRpDevtools = () => {
    const {isEnabled, isForced} = resolveDevtoolsEnabled(rpFeatureFlagDevtools);

    if (!isEnabled) {
        return;
    }

    const amplitudeFetchedFlags = window.__AMPLITUDE_FETCHED_FLAGS__ ?? [];
    delete window.__AMPLITUDE_FETCHED_FLAGS__;

    void waitForAmplitudeInitialization()
        .catch(() => undefined)
        .then(() => import("@pg-mono/devtools"))
        .then(({initDevTools}) => {
            const config: IDevToolsConfig = {
                isForced,
                buildImageTag,
                amplitude: {
                    isInitialized: Boolean(amplitudeApiKey),
                    apiKeyHint: amplitudeApiKey ? amplitudeApiKey.slice(-4) : undefined,
                    deviceId: getAmplitudeDeviceId(),
                    userId: getAmplitudeUserId()
                },
                amplitudeEvents: [],
                abTests: ongoingABTests.map((test: IABTestConfiguration) => ({
                    id: test.id,
                    name: test.name,
                    expires: test.expires,
                    path: test.path,
                    matchOnAllPaths: test.matchOnAllPaths,
                    variants: test.variants,
                    withSSR: test.withSSR,
                    useAmplitude: test.useAmplitude,
                    amplitudeVariantAvailable: test.useAmplitude ? amplitudeFetchedFlags.includes(test.id) : undefined,
                    currentVariant: getABTestCurrentVariant(test.id, test.variants)
                })),
                featureFlags: Object.values(getResolvedFeatureFlags()),
                envVars: window.__INITIAL_ENV__,
                turnstileSimulation: {
                    storageKey: RP_TURNSTILE_SIMULATION_STORAGE_KEY,
                    modes: [
                        {
                            value: TURNSTILE_SIMULATION_CHALLENGE_MODE,
                            label: "Challenge",
                            description: "Wymusza interaktywny modal challenge na testowym sitekey. Testowy token nie jest wysyłany do API."
                        },
                        {
                            value: TURNSTILE_SIMULATION_FAIL_MODE,
                            label: "Fail",
                            description: "Wymusza modal challenge i odrzuca wysłanie z błędem walidacji Turnstile."
                        }
                    ]
                },
                performanceLogs: {
                    storageKey: PERFORMANCE_DEBUG_STORAGE_KEY,
                    eventName: PERFORMANCE_DEBUG_EVENT_NAME,
                    windowKey: PERFORMANCE_DEBUG_WINDOW_KEY,
                    groups: [
                        {
                            id: CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP,
                            label: "Cloudflare Turnstile",
                            description: "Generowanie, prefetch i dołączanie tokenów Turnstile."
                        },
                        {
                            id: RP_LEAD_FORMS_PERFORMANCE_GROUP,
                            label: "RP Lead Forms",
                            description: "Przepływy formularzy leadowych, rejestracji i zapisów preferencji."
                        }
                    ]
                },
                onABTestVariantChange: (test, variant) => {
                    // Same cookie the SSR assignment writes - the reload lets both server and client pick the variant up
                    document.cookie = buildABTestCookie(test.id, variant, test.expires, rpInternalApiCookieDomain);
                    window.location.reload();
                }
            };

            initDevTools(config);
        });
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {buildABTestCookie} from "@pg-mono/ab-testing";
import {getAmplitudeDeviceId, getAmplitudeUserId, getResolvedFeatureFlags, waitForAmplitudeInitialization} from "@pg-mono/amplitude";
import type {IDevToolsConfig} from "@pg-mono/devtools";
import {resolveDevtoolsEnabled} from "@pg-mono/devtools";
import {PERFORMANCE_DEBUG_EVENT_NAME, PERFORMANCE_DEBUG_STORAGE_KEY, PERFORMANCE_DEBUG_WINDOW_KEY} from "@pg-mono/performance-debug";
import {getCookie} from "@pg-mono/request";
import {TURNSTILE_SIMULATION_CHALLENGE_MODE, TURNSTILE_SIMULATION_FAIL_MODE} from "@pg-mono/turnstile";

import {ongoingABTests} from "../common/ab_testing/ongoing_ab_tests";
import {RP_TURNSTILE_SIMULATION_STORAGE_KEY} from "../common/app/constants/storage_keys";
import {CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP, RP_LEAD_FORMS_PERFORMANCE_GROUP} from "../common/app/performance_debug";
import {amplitudeApiKey, buildImageTag, rpFeatureFlagDevtools, rpInternalApiCookieDomain} from "../common/app/read_rp_environment_variables";

declare global {
    interface Window {
        __AMPLITUDE_FETCHED_FLAGS__?: string[];
    }
}

const getABTestCurrentVariant = (testId: string, variants: string[]): string | null => {
    const cookieValue = getCookie(testId);

    if (cookieValue === null) {
        return null;
    }

    // Legacy cookies may store variant index instead of name - resolve to name
    const index = parseInt(cookieValue, 10);

    if (String(index) === cookieValue && index >= 0 && index < variants.length) {
        return variants[index];
    }

    return cookieValue;
};

export const initRpDevtools = () => {
    const {isEnabled, isForced} = resolveDevtoolsEnabled(rpFeatureFlagDevtools);

    if (!isEnabled) {
        return;
    }

    const amplitudeFetchedFlags = window.__AMPLITUDE_FETCHED_FLAGS__ ?? [];
    delete window.__AMPLITUDE_FETCHED_FLAGS__;

    void waitForAmplitudeInitialization()
        .catch(() => undefined)
        .then(() => import("@pg-mono/devtools"))
        .then(({initDevTools}) => {
            const config: IDevToolsConfig = {
                isForced,
                buildImageTag,
                amplitude: {
                    isInitialized: Boolean(amplitudeApiKey),
                    apiKeyHint: amplitudeApiKey ? amplitudeApiKey.slice(-4) : undefined,
                    deviceId: getAmplitudeDeviceId(),
                    userId: getAmplitudeUserId()
                },
                amplitudeEvents: [],
                abTests: ongoingABTests.map((test: IABTestConfiguration) => ({
                    id: test.id,
                    name: test.name,
                    expires: test.expires,
                    path: test.path,
                    matchOnAllPaths: test.matchOnAllPaths,
                    variants: test.variants,
                    withSSR: test.withSSR,
                    useAmplitude: test.useAmplitude,
                    amplitudeVariantAvailable: test.useAmplitude ? amplitudeFetchedFlags.includes(test.id) : undefined,
                    currentVariant: getABTestCurrentVariant(test.id, test.variants)
                })),
                featureFlags: Object.values(getResolvedFeatureFlags()),
                envVars: window.__INITIAL_ENV__,
                turnstileSimulation: {
                    storageKey: RP_TURNSTILE_SIMULATION_STORAGE_KEY,
                    modes: [
                        {
                            value: TURNSTILE_SIMULATION_CHALLENGE_MODE,
                            label: "Challenge",
                            description: "Wymusza interaktywny modal challenge na testowym sitekey. Testowy token nie jest wysyłany do API."
                        },
                        {
                            value: TURNSTILE_SIMULATION_FAIL_MODE,
                            label: "Fail",
                            description: "Wymusza modal challenge i odrzuca wysłanie z błędem walidacji Turnstile."
                        }
                    ]
                },
                performanceLogs: {
                    storageKey: PERFORMANCE_DEBUG_STORAGE_KEY,
                    eventName: PERFORMANCE_DEBUG_EVENT_NAME,
                    windowKey: PERFORMANCE_DEBUG_WINDOW_KEY,
                    groups: [
                        {
                            id: CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP,
                            label: "Cloudflare Turnstile",
                            description: "Generowanie, prefetch i dołączanie tokenów Turnstile."
                        },
                        {
                            id: RP_LEAD_FORMS_PERFORMANCE_GROUP,
                            label: "RP Lead Forms",
                            description: "Przepływy formularzy leadowych, rejestracji i zapisów preferencji."
                        }
                    ]
                },
                onABTestVariantChange: (test, variant) => {
                    // Same cookie the SSR assignment writes - the reload lets both server and client pick the variant up
                    document.cookie = buildABTestCookie(test.id, variant, test.expires, rpInternalApiCookieDomain);
                    window.location.reload();
                }
            };

            initDevTools(config);
        });
};
